import { Box, Alert, Card, Container, Grid, Typography } from '@mui/material';
import React, { Component } from 'react';
import Snackbar from '@mui/material/Snackbar';
import { Helmet } from 'react-helmet';
import ahcStatus from '../../../../models/ahcStatus';
import GoldResults from './GoldResults'
import { _axios } from 'src/plugins/axios';
import commonService from 'src/service/common';
import GoldEmployeesToolbar from './GoldEmployeesToolbar'
import moment from 'moment'

const masterDataCountItems = JSON.parse(JSON.stringify(ahcStatus));

export class GoldEmployees extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalCount: 0,
      dateRange: [],
      goldEmployees: [],
      activeConsultations: [],
      displayEmployees: [],
      selectionData: {
        campLocation: [],
        providerName: [],
        campType: []
      },
      filter: {
        dateRange: [],
        campus: [],
        location: [],
        bene: []
      },
      filterOptions: {
        campusList: [],
        locationList: [],
        beneList: []
      },
      loading: {
        sponseredAndPaidCount: false,
        goldEmployees: false,
        activeConsultations: false,
      },
      server: {
        sponseredAndPaidCount: true,
        goldEmployees: true,
        activeConsultations: true,
      },
      statusCount: masterDataCountItems,
      activeBookingsCount: 0,
      activeTable: 0,
      startIndex:0,
      pageSize: 5
    }
  }


  setLoadingServer(name, loading, server) {
    this.setState((prev) => ({
      loading: {
        ...prev.loading,
        [name]: loading
      },
      server: {
        ...prev.server,
        [name]: server
      }
    }))
  }

  setFilters(obj) {
    this.setState({
      filter: {
        ...obj,
        campus: [],
        location: [],
        bene: []
      }
    }, ()=>{
      this.applyFilters()
    })
  }

  resetFilters() {
    this.setState({
      filter: {
        dateRange: [],
        campus: [],
        location: [],
        bene: []
      },
    })
  }

  fetchFilters() {
    this.setLoadingServer("filter", true, true);
    _axios.post('ahc/filters', {
      "service": 1
    }, {
      ignoreLoading: true,
      headers: {
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      if (response.data && response.data.isSuccess) {
        let city_map = [];
        _.keys(response.data.CityAndId).forEach((each) => {
          let ob = {};
          ob["key"] = each;
          ob["val"] = response.data.CityAndId[each];
          city_map.push(ob);
        })
        this.setState((prev) => ({
          filterOptions: {
            ...prev.filterOptions,
            locationList: city_map,
            campusList: (response.data.result && response.data.result.PrimaryName) ? response.data.result.PrimaryName : [],
            beneList: response.data.result.relation
          },
        }))
        this.setLoadingServer("filter", false, true);
      } else {
        this.setLoadingServer("filter", false, false);
      }
    }).catch((error) => {
      this.setLoadingServer("filter", false, false);
    })
  }

  downloadFile(url) {
    var link = document.createElement("a");
    link.setAttribute('download', '');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  exportFile(filetype){
    let payload = {
      fileType: filetype
    }
    if (this.state.filter.dateRange.length == 2 && this.state.filter.dateRange[0] && this.state.filter.dateRange[1]) {
      payload.apptDateBegin = moment(this.state.filter.dateRange[0]).format('YYYY-MM-DD')
      payload.apptDateEnd = moment(this.state.filter.dateRange[1]).add(1,'days').format('YYYY-MM-DD')
    }
    if (this.state.filter.location.length > 0) {
      payload.location = this.state.filter.location
    }
    if (this.state.filter.campus.length > 0) {
      payload.campus = this.state.filter.campus
    }
    this.setState({ 
      loading: false,
      showSnack: true,
      snackMsg: 'File downloaded in progress...',
      snackType: 'info',
    })
    if(this.state.activeTable == 0){
      this.downloadGoldRawData(payload)
    } else if(this.state.activeTable == 1){
      this.downloadActiveConsultations(payload)
    }
  }

  downloadGoldRawData(payload) {
    _axios.post('gold/goldRawData', {
      "service": 1,
      ...payload
    },{
      ignoreLoading: true,
      headers:{
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    }).then(response =>{
      if(response.data && response.data.isSuccess && response.data.preSignedUrl){
        this.downloadFile(response.data.preSignedUrl)
        this.setState({ 
          loading: false,
          showSnack: true,
          snackMsg: 'File downloaded successfully!',
          snackType: 'success',
        })
      } else if(response.data && !response.data.isSuccess){
        this.setState({ 
          loading: false,
          showSnack: true,
          snackMsg: 'File downloaded failed!',
          snackType: 'error',
        })
      }
    }).catch((error) =>{
      this.setState({ 
        loading: false,
        showSnack: true,
        snackMsg: 'File downloaded failed!',
        snackType: 'error',
      })
    })
  }

  downloadActiveConsultations(payload) {
    _axios.post('gold/availedRawData', {
      "service": 1,
      ...payload
    },{
      ignoreLoading: true,
      headers:{
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    }).then(response =>{
      if(response.data && response.data.isSuccess && response.data.preSignedUrl){
        this.downloadFile(response.data.preSignedUrl)
        this.setState({ 
          loading: false,
          showSnack: true,
          snackMsg: 'File downloaded successfully!',
          snackType: 'success',
        })
      } else if(response.data && !response.data.isSuccess){
        this.setState({ 
          loading: false,
          showSnack: true,
          snackMsg: 'File downloaded failed!',
          snackType: 'error',
        })
      }
    }).catch((error) =>{
      this.setState({ 
        loading: false,
        showSnack: true,
        snackMsg: 'File downloaded failed!',
        snackType: 'error',
      })
    })
  }

  fetchSponseredAndPaidCount() {
    this.setLoadingServer("sponseredAndPaidCount", true, true);
    _axios.post('ahc/sponseredAndPaidCount', {
      service: 1
    }, {
      ignoreLoading: true,
      headers: {
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          const data = [...this.state.statusCount]
          data.forEach(status => {
            for (let i = 0; i < response.data.result.length; i++) {
              const element = response.data.result[i];
              if (element.paid == "true" && status.statusName === "PaidAvailed") {
                status.totalCount += element.split ? element.split : 0;
              } else if (element.paid == "false" && status.statusName === "SponsoredAvailed") {
                status.totalCount += element.split ? element.split : 0;
              }
            }
          });
          this.setLoadingServer("sponseredAndPaidCount", false, true);
          this.setState({
            statusCount: data
          });
        } else {
          this.setLoadingServer("sponseredAndPaidCount", false, false);
        }
      }).catch((error) => {
        this.setLoadingServer("sponseredAndPaidCount", false, false);
      })
  }

  setActiveTable(tab) {
    if (tab == this.state.activeTable) {
      return;
    }
    this.setState({
      activeTable: tab,
      displayEmployees: [],
      startIndex:0,
      pageSize: 5
    }, () => {
      if (tab === 0) {
        this.fetchGoldEmployees()
      } else if (tab === 1) {
        this.fetchActiveConsultations()
      }
    })
  }

  fetchActiveConsultations(obj = {}) {
    let payLoad = {}
    // payLoad["service"] = 1
    payLoad["startIndex"] = this.state.startIndex
    payLoad["pageSize"] = this.state.pageSize
    if(this.state.filter.dateRange && this.state.filter.dateRange[0] && this.state.filter.dateRange[1]){
      payLoad.apptDateBegin = moment(this.state.filter.dateRange[0]).format('YYYY-MM-DD')
      payLoad.apptDateEnd = moment(this.state.filter.dateRange[1]).add(1,'days').format('YYYY-MM-DD')
    }
    Object.keys(obj).map((item) => {
      if (item !== 'dateRange') {
        payLoad[item] = obj[item]
      }
    })
    this.setLoadingServer("activeConsultations", true, true);
    _axios.post('gold/availedRawData', payLoad, {
      ignoreLoading: false,
      headers: {
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          this.setState({
            displayEmployees: response.data.result,
            activeBookingsCount: response.data.totalCount ? response.data.totalCount : 0
          }, () => this.setLoadingServer("activeConsultations", false, true))
        } else {
          this.setLoadingServer("activeConsultations", false, false);
        }
      }).catch((error) => {
        this.setLoadingServer("activeConsultations", false, false);
      })
  }

  onFilterChange(type, value, activeTable) {
    let obj = {}
    switch (type) {
      case 'limit':
        obj.pageSize = value
        break;
      case 'page':
        obj.startIndex = value
        break;
    }

    this.setState(obj, () =>{
      if(activeTable == 0) {
        this.fetchGoldEmployees();
      } else if(activeTable == 1) {
        this.fetchActiveConsultations();
      }
    })
  }

  fetchGoldEmployees(obj = {}) {
    let payLoad = {}

    payLoad["startIndex"] = this.state.startIndex
    payLoad["pageSize"] = this.state.pageSize
    if(this.state.filter.dateRange && this.state.filter.dateRange[0] && this.state.filter.dateRange[1]){
      payLoad.apptDateBegin = moment(this.state.filter.dateRange[0]).format('YYYY-MM-DD')
      payLoad.apptDateEnd = moment(this.state.filter.dateRange[1]).add(1,'days').format('YYYY-MM-DD')
    }
    // payLoad["service"] = 1

    Object.keys(obj).map((item) => {
      if (item !== 'dateRange') {
        payLoad[item] = obj[item]
      }
    })
    this.setLoadingServer("goldEmployees", true, true);
    _axios.post('gold/goldRawData', payLoad, {
      ignoreLoading: false,
      headers: {
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          this.setState({
            displayEmployees: response.data.result,
            activeBookingsCount: response.data.count ? response.data.count : 0
          }, () => this.setLoadingServer("goldEmployees", false, true))
        } else {
          this.setLoadingServer("goldEmployees", false, false);
        }
      }).catch((error) => {
        this.setLoadingServer("goldEmployees", false, false);
      })
  }

  applyFilters() {
    const payload = {}
    if (this.state.filter.campus.length) payload.provider = this.state.filter.campus
    if (this.state.filter.location.length) payload.cityId = this.state.filter.location
    if (this.state.filter.bene.length && this.state.activeTable == 1) payload.benf = this.state.filter.bene
    if (this.state.filter.dateRange.length == 2) {
      payload["apptDateBegin"] = moment(this.state.filter.dateRange[0]).format('YYYY-MM-DD')
      payload["apptDateEnd"] = moment(this.state.filter.dateRange[1]).add(1,'days').format('YYYY-MM-DD')
    }
    if (this.state.activeTable == 0) {
      this.fetchGoldEmployees(payload);
    } else if (this.state.activeTable == 1) {
      this.fetchActiveConsultations(payload);
    }
  }

  componentDidMount() {
    // this.fetchSponseredAndPaidCount();
    this.fetchGoldEmployees();
    // this.fetchFilters()
  }

  render() {
    return (
      <>
        <Helmet>
          <title>Gold | Employees</title>
        </Helmet>
        <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',
            py: 2
          }}
        > <Grid item sx={{
            marginLeft: 3
        }}>
            <GoldEmployeesToolbar setFilters={(e) => this.setFilters(e)}/>
          </Grid>
          <Container maxWidth={false}>
            <Grid container>
              
              <Grid item xs={12}>
                <Card sx={{
                  width: '100%',
                  borderRadius: 4,
                  mb: 2,
                  p: 3,
                  boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)'
                }}>
                  <GoldResults
                    displayEmployees={this.state.displayEmployees}
                    totalCount={this.state.activeBookingsCount}
                    goldEmployees={this.state.goldEmployees}
                    activeConsultations={this.state.activeConsultations}
                    setActiveTable={(e) => this.setActiveTable(e)}
                    activeTable={this.state.activeTable}
                    loading={this.state.loading}
                    server={this.state.server}
                    exportFile = {(filetype) => this.exportFile(filetype)}
                    onPaginationChange={(type, value, activeTable) => this.onFilterChange(type, value, activeTable)} />
                </Card>
              </Grid>
            </Grid>
          </Container>
          <Snackbar open={this.state.showSnack} anchorOrigin={{vertical: 'bottom', horizontal: 'center'}} autoHideDuration={4000} onClose={()=> this.setState({ showSnack: false})}>
            <Alert onClose={()=> this.setState({ showSnack: false})} severity={this.state.snackType}>
              {this.state.snackMsg}
            </Alert>
          </Snackbar>
        </Box>
      </>
    )
  }
}

export default GoldEmployees
